module.exports = __webpack_public_path__ + "img/phone_ch.eaecea1f.png";